export default "__VITE_ASSET__C51rQ2Yi__"